import { render } from "./fidelio.vue?vue&type=template&id=3adc6afa&scoped=true"
import script from "./fidelio.vue?vue&type=script&lang=js"
export * from "./fidelio.vue?vue&type=script&lang=js"

import "./fidelio.vue?vue&type=style&index=0&id=3adc6afa&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3adc6afa"]])

export default __exports__